import { render, staticRenderFns } from "./mileage.vue?vue&type=template&id=64dc4c7e&scoped=true&"
import script from "./mileage.vue?vue&type=script&lang=js&"
export * from "./mileage.vue?vue&type=script&lang=js&"
import style0 from "./mileage.vue?vue&type=style&index=0&id=64dc4c7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dc4c7e",
  null
  
)

export default component.exports